export default "__VITE_ASSET__Wu_IGZQa__"